import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import FluidAvatarImage from '../fluid-avatar-image';
import styles from './avatar-image.scss';

const AvatarImage = ({ component: Component, type, image, className, ...otherProps }) => {
  const componentProps = Component === AvatarImage.defaultProps.component ? omit(otherProps, 'user') : otherProps;

  return (
    <Component className={classNames(styles.image, className, styles[type], 'avatar-image')} {...componentProps}>
      <FluidAvatarImage image={image}/>
    </Component>
  );
};

AvatarImage.LARGE = 'large';
AvatarImage.EXTRA_LARGE = 'extraLarge';
AvatarImage.PROMOTE = 'promote';
AvatarImage.WIDGET = 'widget';
AvatarImage.COMMENT = 'comment';
AvatarImage.COMMENT_SEARCH = 'commentSearch';

AvatarImage.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
};

AvatarImage.defaultProps = {
  component: 'span',
};

export default AvatarImage;



// WEBPACK FOOTER //
// ./app/components/avatar-image/avatar-image.js